import { FullScreenDialog } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { FormDefinitionStore, FormDefinitionStoreContext } from "./FormDefinitionStore";
import { SelectableFormFields } from "./SelectableFormFields";

interface SelectableFormFieldsDialogProps {
	store: FormDefinitionStore;
}

export const SelectableFormFieldsDialog: FunctionComponent<SelectableFormFieldsDialogProps> = observer(({ store }) => {
	return (
		<FormDefinitionStoreContext.Provider value={store}>
			<FullScreenDialog
				PaperProps={{
					sx: { backgroundColor: "var(--cds-grays-gray100)" },
				}}
				disablePortal
				open
			>
				<SelectableFormFields />
			</FullScreenDialog>
		</FormDefinitionStoreContext.Provider>
	);
});
